export interface RewardPointDto
{
    getRewardPoint():string;
    getLastUpdatedDateTime():string;
    setRewardPoint(rewardPoint: string): void;
    setLastUpdatedDateTime(lastUpdatedDateTime: string): void;
}

export class RewardPointDtoImpl implements RewardPointDto
{
    private rewardPoint: string;
    private lastUpdatedDateTime: string;

    setRewardPoint(rewardPoint: string)
    {
        this.rewardPoint = rewardPoint;
    }
    getRewardPoint(): string 
    {
        return this.rewardPoint;
    } 

    setLastUpdatedDateTime(lastUpdatedDateTime: string)
    {
        this.lastUpdatedDateTime = lastUpdatedDateTime;
    }
    getLastUpdatedDateTime(): string 
    {
        return this.lastUpdatedDateTime;
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/rewardpoint/rewardpointdto.ts